import { useCallback } from 'react';

export const useScrollToSection = () =>
    useCallback((sectionId: string, behavior: 'smooth' | 'instant' | undefined = 'smooth') => {
        const section = document.getElementById(sectionId);
        if (section) {
            section.scrollIntoView({ behavior, block: 'start' });
        }
    }, []);
